import { render, staticRenderFns } from "./AddClaim.vue?vue&type=template&id=f509c870&scoped=true&"
import script from "./AddClaim.vue?vue&type=script&lang=js&"
export * from "./AddClaim.vue?vue&type=script&lang=js&"
import style0 from "./AddClaim.vue?vue&type=style&index=0&id=f509c870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f509c870",
  null
  
)

export default component.exports